<ng-container screenAnalytics="notice-missions">
    <div class="modal-header no-icon">
        <h3 class="modal-title">Missions Affected By {{ notice.subject }}</h3>
        <button
            type="button"
            aria-label="Close"
            class="close"
            (click)="onClose()"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body inner-container no-footer">
        <div class="modal-body-content container-scroll">
            <div class="table-container">
                <static-table
                    [availableColumns]="availableColumns"
                    [tableData]="rows"
                    [tableConfig]="tableConfig"
                >
                    <ng-template
                        columnTemplate="acknowledgedBy"
                        let-row="row"
                        let-column="column"
                    >
                        <span *ngIf="row.acknowledgements.length === 0"
                            >&mdash;</span
                        >
                        <span
                            [innerHTML]="
                                formatAcknowledgements(row.acknowledgements)
                            "
                        ></span>
                    </ng-template>
                </static-table>
            </div>
            <ngx-loading [show]="working"></ngx-loading>
        </div>
    </div>
</ng-container>
